export interface INotesTemplateByLegalFormAndAccountBasisRequest {
    legalForm: string;
    accountBasis: string;
}
